import { HttpErrorResponse } from '@angular/common/http';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { ContextMenuItemModel, GridComponent } from '@syncfusion/ej2-angular-grids';

import { Comunidad, LocalStorageKeys, MaterialDto, RolTipoConstants, TenantEnum, Usuario, ExportMediaTypeConstants } from '../../../src/app/shared/model';

@Injectable({
    providedIn: 'root'
})

export class SharedFunctions {

    constructor(
        private router: Router,
        private datePipe: DatePipe,
        protected _http: HttpClient
    ) {
    }

    public showMessage(mensaje: string, titulo: string) {
        DialogUtility.confirm({
            title: titulo,
            content: mensaje,
            okButton: { text: 'Aceptar' },
            cancelButton: { text: '' },
            showCloseIcon: true,
            position: { X: 'center', Y: 'center' },
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }
        });
    }

    public showConfirm(mensaje: string, titulo: string) {
        DialogUtility.confirm({
            title: titulo,
            content: mensaje,
            okButton: { text: 'Aceptar' },
            cancelButton: { text: 'Cancelar' },
            showCloseIcon: true,
            position: { X: 'center', Y: 'center' },
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }
        });
    }

    public handleError(err: HttpErrorResponse, showErrorMessage: boolean = false) {

        console.log(err);
        var errorMessage = "";

        if (err != null)
        {
            switch (err.status)
            {
                //Server caido
                case 0:
                    errorMessage = "Ocurrió un error comunicándose con el servidor";
                    break;

                //Usuario no logueado / Sesion expirada / Token vencido
                case 401:
                    errorMessage = "Su sesión expiró. Por favor iniciela nuevamente";
                    // console.log("error 401", this.router);
                    if (this.router.url.endsWith("auth/login") && this.router.url != "/")
                        this.setLocalStorageValue(LocalStorageKeys.ReturnUrl, this.router.url);
                    this.clearLocalStorage();
                    this.router.navigate(['auth/login']);
                    break;

                default:
                    errorMessage = err?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor";
                    break;
            }
        }
        else
            errorMessage = (err as any)?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor.";

        if (showErrorMessage)
            this.showMessage(errorMessage, "Error");

        return errorMessage;
    }

    public clearLocalStorage() {

        var v = this.getLocalStorageValue(LocalStorageKeys.ReturnUrl);
        localStorage.clear();

        this.setLocalStorageValue(LocalStorageKeys.ReturnUrl, v);
    }

    public setLocalStorageValue(key: string, value: any) {
        try {
            return localStorage.setItem(key, value);
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLocalStorageValue(key: string): any {
        try {
            return localStorage.getItem(key);
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLoggedUser(): Usuario | null {
        try {
            return JSON.parse(this.getLocalStorageValue(LocalStorageKeys.Usuario));
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLoggedUserMenus() {
        try {
            return JSON.parse(this.getLocalStorageValue(LocalStorageKeys.Menu));
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public esUsuarioFinal() {
        var u = this.getLoggedUser();
        return !(u != null && u.Roles != null && u.Roles.some(f => f.RolTipoId != RolTipoConstants.USUARIO))
    }

    public getRichTextToolbarItems(): object {
        return {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
                'SubScript', 'SuperScript', '|',
                'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
                'Indent', 'Outdent', '|', 'CreateLink',
                'Image', '|', 'ClearFormat', 'Print', 'SourceCode' /*, '|', 'FullScreen'*/
            ]
        };
    }

    public getRichTextImageSettings(resource: string, saveUrl: string, removeUrl: string = ""): object | null {
        var loggedUser = this.getLoggedUser();
        if (loggedUser == null || loggedUser.Login == null)
            return null;

        var uploadPath = environment.uploadTempUrl;
        if (!uploadPath.startsWith("http"))
            uploadPath = window.location.origin + uploadPath;

        return {
            // saveFormat: 'Base64',
            path: uploadPath + resource + "/" + loggedUser.Login + "/", //'https://localhost:44376/Temp/MensajeUsuario/admin/',
            saveUrl: saveUrl //'https://localhost:44376/api/mensajeUsuario/attach/temp'
            // removeUrl: removeUrl //'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
        };
    }

    public convertToQueryString<T>(value: T, mediaType: ExportMediaTypeConstants = ExportMediaTypeConstants.Excel) {
        var queryString = "";
        if (value != null) {
            Object.keys(value)?.forEach(e => {

                if (value[e] != null && value[e].toString().length > 0) {
                    queryString += (queryString.length == 0 ? "?" : "&") + e + "=";

                    if ((typeof value[e]).toString() == "object") {
                        //Para verificar si se trata de una fecha
                        if (value[e].toString().includes("GMT"))
                            queryString += this.datePipe.transform(value[e],"yyyy-MM-dd");
                        else
                            queryString += value[e];
                    }
                    else
                        queryString += value[e];
                }
            });
        }

        queryString += (queryString.length == 0 ? "?" : "&") + "mediaType=" + mediaType;
        return queryString;
    }

    public reloadCurrentRoute() {
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate([currentUrl]);
        });
    }

    public getMonthList() {
        return [
            { Id: 1, Nombre: "Enero" },
            { Id: 2, Nombre: "Febrero" },
            { Id: 3, Nombre: "Marzo" },
            { Id: 4, Nombre: "Abril" },
            { Id: 5, Nombre: "Mayo" },
            { Id: 6, Nombre: "Junio" },
            { Id: 7, Nombre: "Julio" },
            { Id: 8, Nombre: "Agosto" },
            { Id: 9, Nombre: "Septiembre" },
            { Id: 10, Nombre: "Octubre" },
            { Id: 11, Nombre: "Noviembre" },
            { Id: 12, Nombre: "Diciembre" }
        ];
    }

    public checkIfFileExists(url: string): Observable<boolean> {
        if (url != null && url.length > 0)
            return this._http.get(url).pipe(map(() => true), catchError(() => of(false)));
        return of(false);
    }

    public formatComunidadName(comunidad: Comunidad): string{
        if((comunidad?.Nombre != null && comunidad?.Nombre?.length > 0) && (comunidad?.Direccion != null && comunidad?.Direccion?.length > 0)){
            return `${comunidad.Nombre.toUpperCase()} (${comunidad.Direccion})`;
        }else if(comunidad?.Nombre != null && comunidad?.Nombre?.length > 0){
            return `${comunidad.Nombre.toUpperCase()}`;
        }
        return "";
    }

    public formatMaterial(material: MaterialDto): string{
        if((material?.Nombre != null && material?.Nombre?.length > 0)){
            return `${material.Nombre.toUpperCase()}`;
        }
        return "";
    }

    public getNombreMenuTenant(nombre: string): string {
        try {
            var menuNameList = this.getLocalStorageValue(LocalStorageKeys.NamesToReplace);
            if (menuNameList != null && menuNameList.length > 0)
                return JSON.parse(menuNameList)[nombre] ?? nombre;
            return nombre;
        }
        catch {
            return nombre;
        }
    }

    private getReporteFiltrosKeyName(reporte: string): string {
        if (reporte != null && reporte.length > 0) {
            var loggedUser = this.getLoggedUser();
            if (loggedUser != null && loggedUser.Login != null && loggedUser.Login.length > 0) {
                return ("filtros_"+loggedUser.Login+"_"+reporte);
            }
        }

        return "";
    }

    public setReporteFiltros(reporte: string, filtros: any) {
        var reporteKey = this.getReporteFiltrosKeyName(reporte);
        if (reporteKey != null && reporteKey.length > 0) {
            const objetoSerializado = filtros != null ? JSON.stringify(filtros) : null;
            this.setLocalStorageValue(reporteKey, objetoSerializado);
        }
    }

    public getReporteFiltros(reporte: string) {
        var reporteKey = this.getReporteFiltrosKeyName(reporte);
        if (reporteKey != null && reporteKey.length > 0) {
            var valor = this.getLocalStorageValue(reporteKey);
            return JSON.parse(valor);
        }
        return null;
    }

    public getFileExtension(mediaType: ExportMediaTypeConstants) {
        switch (mediaType) {
            case ExportMediaTypeConstants.Csv: return ".csv";
            case ExportMediaTypeConstants.Excel: return ".xlsx";
        }

        return "";
    }

    // @HostListener('window:resize', ['$event'])
    public sizeView() {
       return (window.screen.width < 500);
    }

    public isRosbacoUser(): boolean {
        var tenantId = this.getLocalStorageValue(LocalStorageKeys.TenantId);
        return (tenantId == TenantEnum.Rosbaco);
    }

    private readonly SHOW_ALL_ID = 'showAllColumns';
    private readonly HIDE_ALL_ID = 'hideAllColumns';

    public initializeContextMenu(
      gridColumns: { field: string; headerText: string }[],
    ): ContextMenuItemModel[] {
      return [
        ...this.generateColumnToggleItems(gridColumns),
        { target: '.e-content', separator: true },
        {
          text: 'Mostrar todas las columnas',
          target: '.e-content',
          id: this.SHOW_ALL_ID,
          iconCss: 'fa fa-eye fa-1x'
        },
        {
          text: 'Ocultar todas las columnas',
          target: '.e-content',
          id: this.HIDE_ALL_ID,
          iconCss: 'fas fa-eye-slash'
        }
      ];
    }

    private generateColumnToggleItems(gridColumns: { field: string; headerText: string }[]): ContextMenuItemModel[] {
      return gridColumns.map(column => ({
        text: '',
        target: '.e-content',
        id: column.field,
        iconCss: 'fa fa-eye fa-1x',
      }));
    }

    public updateMenuItemState(
      menuItems: ContextMenuItemModel[],
      target: any,
      grid: GridComponent,
      gridColumns: { field: string; headerText: string }[],
    ): boolean {

      if(target.closest('.e-rowcell') !== null) {
        menuItems.forEach(item => {
          if (item.id !== this.SHOW_ALL_ID && item.id !== this.HIDE_ALL_ID) {
            const columnField = item.id ?? "";
            const columnConfig = gridColumns.find(col => col.field === columnField);
            if (columnConfig) {
              const column = grid.getColumnByField(columnField);
              if (column) {
                const isVisible = column.visible;
                item.text = isVisible
                  ? `Ocultar columna ${columnConfig.headerText}`
                  : `Mostrar columna ${columnConfig.headerText}`;
                item.iconCss = isVisible
                  ? 'fas fa-eye-slash'
                  : 'fa fa-eye fa-1x';
              }
            }
          }
        });
        return false
      }

      return true
    }

    public setColumnsVisibility(
      id: string,
      grid: GridComponent,
      gridColumns: { field: string; headerText: string }[],
      visible?: boolean | null,
      columnVisibility? : { [key: string]: boolean }
    ): void {
      if (id === this.SHOW_ALL_ID || id === this.HIDE_ALL_ID) {
        const columnFields = gridColumns.map(col => col.field);
        columnFields.forEach(field => {
          const column = grid.getColumnByField(field);
          if (column) {
            if (visible === undefined || visible === null) {
              column.visible = (id === this.SHOW_ALL_ID);
              if (columnVisibility) columnVisibility[field] = (id === this.SHOW_ALL_ID);
            } else {
              column.visible = visible;
              if (columnVisibility) columnVisibility[field] = visible;
            }
          }
        });
      } else {
        const column = grid.getColumnByField(id);
        if (column) {
          if (visible === undefined || visible === null) {
            column.visible = !column.visible;
            if (columnVisibility) columnVisibility[id] = column.visible;
          } else {
            column.visible = visible;
            if (columnVisibility) columnVisibility[id] = visible;
          }
        }
      }

      grid.refresh();
    }

    /*Toma un string con texto en formato html,
    y devuelve solo el texto sin las etiquetas*/
    public getOnlyTextFromHtml(textWithHtml: string): string {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = textWithHtml;

        return tempElement.innerText;
    }
}
